import { z } from 'zod';
/**
 * Website name validation (`technical.md`, Shared validation functions).
 * The 100-character limit is a practical guard; no business rule specifies one.
 */
export const websiteNameSchema = z.string().trim().min(1, 'Enter a website name.').max(100);
/** At most this many suggested questions show in the widget. */
export const MAX_SUGGESTED_QUESTIONS = 4;
/**
 * A website's suggested questions, written by its owner: each one short
 * enough to fit on a tap target in the widget. Blank ones are dropped.
 */
export const suggestedQuestionsSchema = z
    .array(z.string().trim().max(80, 'Keep each question to 80 characters or fewer.'))
    .transform((questions) => questions.filter((q) => q !== ''))
    .pipe(z
    .array(z.string())
    .max(MAX_SUGGESTED_QUESTIONS, `Add up to ${MAX_SUGGESTED_QUESTIONS} questions.`));
//# sourceMappingURL=website.js.map